export default "__VITE_ASSET__jFKQw8UI__"